<template>
  <div id="properties_tab" class="relative my-6">
    <NotificationPopup
      v-if="widget.edited"
      status="warning"
      title="Changes Unpublished"
      text="To view your updates on the widget, please save and publish them."
      class="mb-6"
    />
    <div v-if="widget_info?.user">
      <PropertyBlock
        v-for="(w_source, index) in principalSources"
        :key="`${index}${w_source.principal_id}`"
        :principal_id="w_source.principal_id"
        :sources="w_source.sources"
        :principals="widget_info.principals"
        :widgets="widget"
        @updateWidget="updateWidget"
      />
    </div>

    <OverlaySpinner
      v-else
      :hasOverlay="false"
      class="h-[50vh]"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { WidgetI } from "@/interfaces/interfaces";

import PropertyBlock from "@/components/edittabs/PropertyBlock.vue";
import NotificationPopup from "@/components/notifications/NotificationPopup.vue";
import OverlaySpinner from '@/components/loader/OverlaySpinner.vue';

export default defineComponent({
  name: "PropertiesTab",
  components: {
    PropertyBlock,
    NotificationPopup,
    OverlaySpinner,
  },
  props: {
    widget_info: {
      type: Object,
    },
    widgets:{
      type: Object as PropType<WidgetI>,
      default: () => ({}),
    }
  },
  emits:['updateWidget'],
  data(){
    return {
      isShowSavePopup: false,
      widget:{} as WidgetI
    }
  },
  mounted() {
    this.widget = this.widgets;
  },
  computed: {
    principalSources() {
      return this.widget_info?.principal_sources.filter(({ sources }: { sources: [] | null; }) => sources);
    },
  },
  methods:{
    updateWidget(){
      this.widget.edited = true;
      this.$emit('updateWidget', this.widget)
    },
  },
  watch: {
    widgets: function (widgets: WidgetI) {
      this.widget = widgets
    }
  }
})
</script>
